module.exports = __webpack_public_path__ + "img/pic14.55ad2c78.jpg";